import styles from "./StatusButton.module.css";

type Props = {
  count: number;
};

export const ProgressBtton = (props: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>WIP</div>
      <div className={styles.status}>
        <span className={styles.wipText}>{props.count}</span> items
      </div>
    </div>
  );
};
